"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _compact_props = _interopRequireDefault(require("./utils/compact_props"));

var _star_component = _interopRequireDefault(require("./component/star_component"));

var _label_component = _interopRequireDefault(require("./component/label_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Rating =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Rating, _PureComponent);

  /**
   * 组件属性说明
   * @alias RatingProps
   * @description 用于评价打分。
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基本属性
   * @property {number} value=0 评分值
   * @property {func} [onChange] 评分值变更<br />onChange=(event, value)
   * @property {number} [max=5] 最多得分
   * @property {string} [label=''] 文案
   * @property {bool} [readOnly=false] 是否只读
   * @property {bool} [clear=false] 是否可清空
   * @property {bool} [half=false] 是否支持半星
   * @property {ele|func} [StarComponent] 星结构组件<br />&lt;StarComponent type='full|half|empty' value='' /&gt;
   * @property {ele|func} [LabelComponent] 文案结构组件<br />&lt;LabelComponent label='' /&gt;
   *
   * @see
   *
   * onChange typings:
   *     (event: any, value: any) => any
   *
   */
  function Rating(props) {
    var _this;

    _classCallCheck(this, Rating);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rating).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
    _this.state = {
      value: props.value || 0
    };
    return _this;
  }

  _createClass(Rating, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          value: nextProps.value || 0
        });
      }
    } // 移入的话临时展示选中的数据

  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(event) {
      // 获取html上的属性值
      var getHtmlAttributeValue = function getHtmlAttributeValue() {
        var attributeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return parseFloat(event.target.getAttribute(attributeName) || '') || 0;
      };

      var _compactProps = (0, _compact_props["default"])(this.props),
          readOnly = _compactProps.readOnly;

      var _compactProps2 = (0, _compact_props["default"])(this.props),
          half = _compactProps2.half;

      var result = 0;
      var value = 0;
      var halfValue = 0; // 有结构非可读就获取对应内容

      if (event.target && !readOnly) {
        value = getHtmlAttributeValue('data-value');
        halfValue = getHtmlAttributeValue('data-halfvalue'); // 半星的使用data-halfvalue
        // 全星的使用data-value

        if (half) {
          result = halfValue;
        } else {
          result = value;
        } // 只有大于0的才算有效


        if (result > 0) {
          this.setState({
            value: result
          });
        }
      }
    } // 移出的话就还原回来

  }, {
    key: "handleMouseOut",
    value: function handleMouseOut() {
      var _this$props$value = this.props.value,
          value = _this$props$value === void 0 ? 0 : _this$props$value;

      var _compactProps3 = (0, _compact_props["default"])(this.props),
          readOnly = _compactProps3.readOnly;

      if (!readOnly) {
        this.setState({
          value: value
        });
      }
    } // 点击的话就正式选中数据

  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          propsValue = _this$props.value;

      var _compactProps4 = (0, _compact_props["default"])(this.props),
          readOnly = _compactProps4.readOnly;

      var _compactProps5 = (0, _compact_props["default"])(this.props),
          clear = _compactProps5.clear;

      var value = this.state.value;
      var result;

      if (!readOnly && (0, _spauiUtils.isFunction)(onChange)) {
        if (propsValue === value && clear) {
          result = 0;
        } else if (propsValue !== value) {
          result = value;
        }

        if (typeof result !== 'undefined') {
          onChange(event, result);
        }
      }
    }
  }, {
    key: "getStarsDom",
    value: function getStarsDom() {
      var _this$props2 = this.props,
          max = _this$props2.max,
          StarComponent = _this$props2.StarComponent;
      var value = this.state.value;
      var floatValue = parseFloat(value) || 0;
      var floorValue = Math.floor(floatValue) || 0; // 向下取整

      var halfValue = floatValue - floorValue;
      var result = [];
      var tempValue = 0;
      var i = 0;

      for (; i < floorValue; i++) {
        tempValue = tempValue + 1;
        result.push(_react["default"].createElement(StarComponent, {
          type: "full",
          value: tempValue,
          key: tempValue
        }));
      }

      if (halfValue === 0.5) {
        tempValue = tempValue + 1;
        result.push(_react["default"].createElement(StarComponent, {
          type: "half",
          value: tempValue,
          key: tempValue
        }));
      }

      i = result.length;

      for (; i < max; i++) {
        tempValue = tempValue + 1;
        result.push(_react["default"].createElement(StarComponent, {
          type: "empty",
          value: tempValue,
          key: tempValue
        }));
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          LabelComponent = _this$props3.LabelComponent,
          label = _this$props3.label,
          title = _this$props3.title;

      var _compactProps6 = (0, _compact_props["default"])(this.props),
          readOnly = _compactProps6.readOnly;

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-rating', {
          readonly: readOnly
        })
      }, Rating), {
        title: ""
      }), _react["default"].createElement("div", {
        className: "spaui-rating-stars",
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        onClick: this.handleClick,
        title: title
      }, this.getStarsDom()), _react["default"].createElement(LabelComponent, {
        label: label
      }));
    }
  }]);

  return Rating;
}(_react.PureComponent); // 组件标记


_defineProperty(Rating, "propTypes", {
  value: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.number, _spauiUtils.PropTypes.string]).isRequired,
  onChange: _spauiUtils.PropTypes.func,
  max: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.number, _spauiUtils.PropTypes.string]),
  label: _spauiUtils.PropTypes.string,
  readOnly: _spauiUtils.PropTypes.bool,
  clear: _spauiUtils.PropTypes.bool,
  half: _spauiUtils.PropTypes.bool,
  StarComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element]),
  LabelComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.element])
});

_defineProperty(Rating, "defaultProps", {
  value: 0,
  max: 5,
  label: '',
  readOnly: false,
  clear: false,
  half: false,
  StarComponent: _star_component["default"],
  LabelComponent: _label_component["default"]
});

(0, _spauiUtils.setComponentMark)(Rating, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Rating;
exports["default"] = _default;